import { render, staticRenderFns } from "./CbsRegister.vue?vue&type=template&id=18dbf566"
import script from "./CbsRegister.vue?vue&type=script&lang=js"
export * from "./CbsRegister.vue?vue&type=script&lang=js"
import style0 from "./CbsRegister.vue?vue&type=style&index=0&id=18dbf566&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports